export const noop: (...args: any[]) => void = () => undefined;
export const noops: (...args: any[]) => void = () => undefined;
